<template lang="pug">
  b-navbar.header(:toggleable="toggleableValue", type="dark")
    // 로고 및 사이드바 버튼
    button.sidebar-open-button(
      type="button",
      @click="toggleSidebar")
      icon(name="folder", scale="2")
    b-navbar-brand.logo.text-center.p-0
      a.logo-link(
        href="https://linkmemine.co.kr",
        target="_blank",
        rel="noopener noreferrer"
      )
        l-image(:src="`${AppState.Path.upload}/${user.profile}.png?cache=${timestamp}`", :placeholder="`${AppState.Path.image}/main_logo.png`", contain)
    // 토글 버튼
    b-navbar-toggle(target="nav_collapse")
    
    // Collapse 영역
    b-collapse#nav_collapse.collapse-wrap(is-nav)
      b-navbar-nav.nav
        b-nav-item(:to="{name: 'device-root'}")
          img(src="../../../assets/agent-icon.svg")
          span.text(v-t="'all-devices'")
        b-nav-item(v-if="AppState.perm.isAdmin" :to="{name:'groups'}")
          img(src="../../../assets/group-icon.svg")
          span.text {{$t('groups')}}
        b-nav-item(:to="{name: 'profile'}")
          img(src="../../../assets/user-icon.svg")
          span.text {{$t('account-manage')}}
        b-nav-item.d-none.d-md-block(v-if="(AppState.isCorporate && AppState.perm.isAdmin) || statistics", :to="{name: 'statistics'}")
          img(src="../../../assets/statistics-icon.svg")
          span.text {{$t('dashboard')}}
        b-nav-item.d-none.d-md-block(:to="{name: 'ticket-request'}" v-if="AppState.env.VUE_APP_TICKET_ENABLE")
          icon(name="cog")
          span.text(v-t="'access-ticket'")
        b-nav-item(v-if="!AppState.isMobile" :to="{name: 'support'}")
          img(src="../../../assets/download-icon.svg")
          span.text {{$t('download')}}
        b-nav-item(v-if="!AppState.isStandalone && AppState.perm.isAdmin && !AppState.isMobile", :to="{name:'license'}")
          img(src="../../../assets/pay-icon.svg")
          span.text {{$t('payment_manage')}}
          
      // 우측 네비게이션 요소
      b-navbar-nav.right-nav.ml-auto.d-flex.align-items-center
        div.contact(v-if="!AppState.isStandalone", @click="redirectConsult")
          img.consulting-img.mr-1(src="../../../assets/naver-talk.png")
          button.consulting(
            type="button",
          ) {{$t('chat_talk')}}
        b-nav-item.cursor-pointer(@click="toggleViewMode")
          span.mr-2.fixed-width(:class="isSimpleMode ? 'view-mode-simple' : 'view-mode-normal'") {{viewMode.toUpperCase()}}
          switches.lmm-switch(
            v-model="isSimpleMode",
            theme="bootstrap",
            :color="isSimpleMode ? 'success' : 'default'"
          )
        div(v-if="AppState.perm.isAdmin")
          span.adminId(v-t="'manager-id'" style="color: #FFFFFF")
        div(v-else-if="AppState.perm.isSubManager")
          span.adminId(v-t="'sub-manager-id'" style="color: #FFFFFF")
        b-nav-item(:to="{name: 'notice'}")
          img.header-menu-icon(src="../../../assets/announcement-icon.svg")
        b-nav-item(target="_blank", href="https://linkmemine.freshdesk.com/support/home" style="padding: 0 1rem")
          img.header-menu-icon(src="../../../assets/faq-icon.svg")
          span.text {{$t('customer_support')}}
        b-nav-item.d-none.d-lg-flex.language(@click="setDropdown('language')")
          span.text {{lang.current.text}}
          icon(name="caret-down")
          transition(name="dropdown")
            div.header-dropdown.select-language(v-if="dropdownState === 'language'")
              ul
                li(v-for="la in lang.options", :key="la.value", @click="selectLang(la)") {{la.text}}
        b-nav-item.logout(@click="logout")
          span.text(v-t="'logout'")
    div.footer
</template>

<script>
import Switches from 'vue-switches'
import _ from 'lodash'
import {store} from '@/api/store'
import {logout, user} from '@/api/access'
import {DeviceAPI} from '@/api'
import {setPermission} from '../../../api/access'
import {getCurrentLanguage} from '@/i18n'
import {EventBus} from "../../manage/EventBus";

const checkDelay = {
  active: 12000,
  deactive: 1200000
}

export default {
  name: 'manager-header',
  components: { Switches },
  methods: {
    toggleSidebar () {
      this.AppState.Sidebar = !this.AppState.Sidebar
    },
    setDropdown (key) {
      if (this.dropdownState === key) this.dropdownState = null
      else this.dropdownState = key
    },
    selectLang (lang) {
      let {name, params, query} = this.$route
      params.lang = lang.value
      this.$router.push({name, params, query})
    },
    getSummary (cb) {
      if (this.onProgress) return
      this.onProgress = true
      DeviceAPI
        .get('summary')
        .then(resp => {
          this.onProgress = false
          let newSum = resp.data.objects[0]
          let ticket = resp.data.meta
          if (!_.isEqual(this.summary, newSum)) {
            store.set('summary', newSum)
            this.AppState.$emit('summary-update', newSum)
            this.summary = newSum
            this.AppState.$emit('device-state-change')
            this.AppState.setSummary(newSum)
          }
          if (!_.isEqual(this.tickets, ticket)) {
            store.set('tickets', ticket)
            this.tickets = ticket
            this.AppState.setTicketSummary(ticket)
            this.AppState.$emit('ticket-state-change')
            if (cb) cb(ticket)
          }
          setPermission(this.user, true)
        })
    },
    getSummaryInterval () {
      if (this.checker.timer) clearInterval(this.checker.timer)
      this.getSummary()
      this.checker.timer = setInterval(() => {
        this.getSummary()
      }, this.checker.delay)
    },
    async logout () {
      await logout()
      // 로그인 페이지로 이동
      const {lang} = this.$route.params
      this.$router.push({name: 'login', params: { lang }})
    },
    redirectConsult() {
      window.open('https://talk.naver.com/ct/w5wmn6', '_blank')
    },
    toggleViewMode() {
      this.viewMode = this.viewMode === 'simple' ? 'normal' : 'simple'
    }
  },
  created () {
    let stored = store.get('summary')
    this.viewMode = store.get('viewMode') || 'normal'
    if (stored) {
      this.summary = stored
      this.AppState.setSummary(stored)
    }

    let storedTicket = store.get('tickets')
    if (storedTicket) {
      this.tickets = storedTicket
      this.AppState.setTicketSummary(stored)
    }

    this.getSummary(ticket => {
      if (!storedTicket && ticket.request_ticket) {
        this.$awn.info(this.$t('has_request_ticket', {count: ticket.request_ticket}))
      }
    })
    this.getSummaryInterval()
    this.AppState.$on('logo-changed', () => {
      this.timestamp = new Date().getTime()
    })

    window.onblur = () => {
      this.checker.delay = checkDelay.deactive
      this.getSummaryInterval()
    }

    window.onfocus = () => {
      this.checker.delay = checkDelay.active
      this.getSummaryInterval()
    }

    let lang = this.$route.params.lang
    this.lang.current = _.find(this.lang.options, {value: lang})

    this.AppState.$on('app-logout', () => {
      this.logout()
    })

    this.currentLang = lang

    //통계탭 분기처리
    let authVal = this.user.auth_val
    authVal = authVal.split(',')
    for (var i = 0; i < authVal.length; i++) {
      if (authVal[i] == 8) {
        this.statistics = true
      } else {
        this.statistics = false
      }
    }
  },
  watch: {
    $route (r) {
      let lang = r.params.lang
      this.lang.current = _.find(this.lang.options, {value: lang})
    },
    viewMode(newValue) {
      store.set('viewMode', newValue)
      EventBus.$emit('view-mode-changed', newValue)
      if (this.$route.path !== '/ko/device/all') {
        this.$router.push({name: 'device-root'})
      }
      this.AppState.viewMode = newValue
    }
  },
  computed: {
    toggleableValue() {
      return this.currentLang === 'ko' ? 'gnb_ko' : 'gnb_en';
    },
    isSimpleMode: {
      get() {
        return this.viewMode === 'simple'
      },
      set(value) {
        this.viewMode = value ? 'simple' : 'normal'
      }
    }
  },
  beforeDestroy () {
    window.onblur = null
    window.onfocus = null
    if (this.checker.timer) clearInterval(this.checker.timer)
    this.AppState.$off('logo-changed')
  },
  data () {
    const userData = user()
    let initDelay = document.hasFocus() ? checkDelay.active : checkDelay.deactive
    let currentLang = getCurrentLanguage()
    if (currentLang === 'ko') currentLang = 'kr'
    return {
      onProgress: false,
      timestamp: 0,
      dropdownState: null,
      summary: null,
      tickets: null,
      checker: {
        timer: null,
        delay: initDelay
      },
      lang: {
        current: null,
        options: [
          { value: 'ko', text: 'KO' },
          { value: 'en', text: 'EN' },
          // { value: 'ja', text: 'JA' }
        ]
      },
      osIcons: ['desktop', 'brands/windows', 'brands/linux', 'brands/apple', 'brands/android', 'mobile'],
      user: userData,
      manual: `${this.AppState.Path.download}/manual/${currentLang}`,
      statistics: false,
      menuDevice: false,
      viewMode: 'normal',
    }
  }
}
</script>
<style lang="scss" scoped>
$nav-background-color: #232F3E;
.header {
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 53px;
    padding: 0;
    background-color: $nav-background-color;
    z-index: 1071;
}

.footer {
    position: fixed;
    bottom: 0; left: 0;
    width: 100%; height: 30px;
    padding: 0;
    background-color: $nav-background-color;
    z-index: 1071;
}

.collapse-wrap {
  background-color: $nav-background-color;
}

.select-language-in-mobile {
  padding: 0 20px;
}

.sidebar-open-button {
  border: 0;
  background-color: transparent;
  color: white;
  outline: none;
  @media (min-width: 992px) { display: none; }
}

.alert-count {
  transform: translate(-5px, -10px);
}

.logo {
  // 임시 패딩값 나중엔 중앙정렬
  padding-top: 7px;
  margin: 1.5rem;
  width: 170px; height: 20px;
  float: left;

  .logo-link {
    display: flex;
    width: 170px; height: 20px;
    align-items: center;
    justify-content: center;
  }
}

.os {
  display: inline-block;
  width: 60px;
  .os-icon {}
  .os-text {
    display: inline-block;
    padding: 0 10px;
  }
}

.os-wrap {
  cursor: default;
  border-top: 1px solid #ebebeb;
  background-color: #f0f0f0;
}

.status {
  cursor: default;
  // .status-label {}
  .status-value {
    float: right;
  }
}

//.select-language
.header-dropdown {
  position: absolute;
  top: 52px; right: 0;
  ul {
    padding: 0;
    list-style: none;
    border: 1px solid #ebebeb;
    background-color: white;
    li {
      color: #888;
      padding: 0 20px;
    }
  }

  &.summary {
    ul {
      li {
        white-space: nowrap;
        min-width: 120px;
      }
    }
  }
}

.right-nav {
  > li {
    line-height: 50px;

    > a {
      display: block;
      padding: 0 1rem !important;
      height: 53px;
      color: #fff;
      font-size: 13px;
      // line-height: 60px;

      > svg { vertical-align: middle; }
      > .text {
        display: inline-block;
        padding: 0 5px;
        vertical-align: top;
      }
      
    }
    &.alert-icon {
      position: relative;
    }
    // &.logout {}
    &.language {
      position: relative;
      @media (max-width: 768px) {
        > a {
          height: auto;
          .select-language {
            position: relative;
            top: auto; right: auto;
          }
        }
      }
    }
  }
}

.nav {
  > li {
    line-height: 50px;
    position: relative;
    > a {
      padding: 0 20px !important;
      height: 53px;
      color: #d6d6d6;
      font-size: 13px;
      display: flex;
      justify-content: center;
      align-items: center;

      > svg { vertical-align: middle; }
      > .text {
        display: inline-block;
        padding: 0 5px;
        vertical-align: top;
      }

      &:hover {
        color: #EC7211;
        img {
          filter: invert(51%) sepia(52%) saturate(951%) hue-rotate(347deg) brightness(91%) contrast(104%);
        }
      }

      &.nav-link.router-link-active {
        color: #EC7211;
        font-weight: 500;
        img {
          filter: invert(51%) sepia(52%) saturate(951%) hue-rotate(347deg) brightness(91%) contrast(104%);
        }
        // border-bottom: 4px solid #31b6ca;
      }
    }
  }
  //drop-menu 미완성
  .drop-menu {
    position: absolute;
    // transform: translate(-50%, -50%);
    // left: 50%;
    // top: 195%;
    top: 53px;
    left: 0;
    margin: 0;
    padding: 0;
    box-shadow: 0px 0px 7px 5px rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    > li {
      list-style: none;
      background: #eee;
      width: 109px;
      text-align: center;
      border-radius: 2px;
      &:hover {
        color: #31b6ca;
      }
      &:hover a {
        color: #31b6ca;
      }
      > a {
        text-decoration: none;
        color: #232323;
      }
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}

.adminId {
  color:#ec7211;
  line-height: 50px;
  padding: 0 10px;
  font-size: 13px;
}

.download {
  color: #f1f1f1;
}

span.download {
  padding-left: 3px;
}

@media (max-width: 991px) {
  .mobile-language {
    border-top: 1px solid #5d5d5d;
  }
  .nav > li > a.nav-link{
    &.router-link-active {
      background-color: transparent;
      color: #31b6ca;
      font-weight: 500;
      border-bottom: 0px;
    }
    &:hover {
      background-color: transparent;
      color: #31b6ca;
      font-weight: 500;
      border-bottom: 0px;
    }
  }
}

.nav-link {
  display: flex !important;
  align-items: center;
}

.view-mode-simple {
  color: #EC7211;
  font-size: 13px;
  font-weight: 400;
}

.view-mode-normal {
  color: #D2D2D2;
  font-size: 13px;
  font-weight: 400;
}

.select-language {
  > ul {
    background-color: #232F3E;
    border: #232F3E;
    > li {
      color: #D2D2D2 ;
    }
    > li:hover {
      color: #FFFFFF;
    }
  }
}

.header-menu-icon {
  &:hover, &.active {
  filter: invert(51%) sepia(52%) saturate(951%) hue-rotate(347deg) brightness(91%) contrast(104%);
  }
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  30% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.contact:hover .consulting {
  background-color: #95d5b2;
  color: #fff;
}

.consulting {
  background-color: #ffffff;
  color: #03c75a;
  border: 2px solid #03c75a;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.3s ease, color 0.3s ease;
  white-space: nowrap;
}

.consulting-img {
  width: 20px !important;
  cursor: pointer;
}

.fixed-width {
  display: inline-block;
  width: 60px;
  text-align: right;
  white-space: nowrap;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
